import React from "react";
import styled from "@emotion/styled";
import { Sizes } from "../../../styles";
import Card from "./Card";

const SuccessStoriesList = () => {


	return (
		<List>
			<Card />
		</List>
	)
}

export default SuccessStoriesList;

const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 6rem 0;
    display: grid;
    row-gap: 4rem;

    @media only screen and (min-width: ${Sizes.screens.large}) {
        grid-template-columns: repeat(2, 1fr);
        gap: 2.4rem 4rem
    }
`;
